
// THIS IS OLD approach Patch
// use ??? Instead

// generic map for icon type -> icon class (ii5)

import {ItemIconConfig} from "./config";

const generate = () : DictionaryStringString => {

    // console.count('generate')

    const result: DictionaryStringString = {}

    ItemIconConfig.forEach(itemIcon => {

        result[itemIcon.name] = itemIcon.className
    })

    return result
}

const dict : DictionaryStringString = generate()

export const ItemIconClass = dict
